import React, { useEffect, useState } from 'react'
import PropTypes from 'prop-types'

// Components - imported
import { Avatar, Button } from '@material-ui/core';

// Icons
import ArrowBackIcon from '@material-ui/icons/ArrowBack';

import KeyboardArrowDownIcon from '@material-ui/icons/KeyboardArrowDown';

import monthData from '../../../utils/calenderData/months';
import dayData from '../../../utils/calenderData/days';
import yearData from '../../../utils/calenderData/years';

const AddStartDate = ({
    slideform3, 
    setSlideForm3,
    slideform2, 
    setSlideForm2,
    formData, 
    onChange,
    user,
    is_create_page,
}) => {

    const [processing, setProcessing] = useState(false);

    // Toggle the value of slideform1 to go back to the previous form step
    const goBack = (e) => {
        setSlideForm2(!slideform2);
    }

    // Toggle the slideform1 state variable (go to next page in slide form)
    const todo = (e) => {
        console.log('NEXT PAGE');
        console.log('start day: ', formData.start_day)
        console.log('start time: ', formData.start_time)
        setSlideForm3(!slideform3);
    }

    const { start_day, start_time } = formData;

    return (
        <div className="form-transition-element">

            {/* Back Button */}
            {!is_create_page && (
                <div onClick={goBack} className="form__backBtn">
                    <ArrowBackIcon />
                </div>
            )}

            {/* Display the heading */}
            <div>
                <h2>Add a description</h2>
            </div>

            {/* Header Description */}
            <div>
                <div style={{color:'rgb(83, 100, 113)', textAlign:'center', fontSize:'1rem', fontWeight:'500', marginTop:'5px', lineHeight:'20px', overflowWrap:'break-word'}}>
                    <span>Describe this group so people know what it's about.</span>
                </div>
            </div>

            {/* Input Box for Bio text */}
            <div className="modal__inputs" style={{flex:1, paddingLeft:'5px'}}>
                <input type="date" name="start_day" id="dateInput" value={start_day} onChange={e => onChange(e)} />
                <input type="time" name="start_time" id="timeInput" value={start_time} onChange={e => onChange(e)} />
            </div>

            <Button 
                // disabled={!start_day || !start_time}
                onClick={todo}
                variant="outlined" 
                className={`sidebar__tweet black`}
                fullWidth
            >
                Next
            </Button>

            <Button 
                onClick={goBack}
                variant="outlined" 
                className="sidebar__tweet heart"
                fullWidth
            >
                Go Back
            </Button>

            <div className="auth__footer">
                {/* <a href={`/register`}>Forgot password?</a>
                <a href={`/login`}>Log In</a> */}
            </div>
        </div>
    )
}

AddStartDate.propTypes = {

}

export default AddStartDate
